import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { frontPage } from './request';
import { func } from '@/utils/public';
import exhibition from '@/views/system/customManage/exhibition.vue';
import passwordSafeModal from '@/views/system/accountManage/passwordSafeModal.vue';
import { mapState } from 'vuex';
export default {
  components: {
    exhibition,
    passwordSafeModal
  },
  data() {
    return {
      previewList: [],
      isGetData: true,
      visibleModal: false
    };
  },
  computed: {
    ...mapState({
      complexityPopup: state => state.user.complexityPopup
    })
  },
  created() {
    frontPage({}).then(res => {
      this.isGetData = false;
      if (res.length == 0) {
        return false;
      }
      const arr = res.sort(func) || [];
      let arr_new = [null, null, null, null, null];
      arr.map(item => {
        arr_new.splice(item.sort - 1, 1, item);
      });
      this.previewList = arr_new;
      console.log(this.previewList, 2221);
    });
  },
  mounted() {
    /**
     * 密码安全弹框是否显示
     * complexityPopup: 'true' 弹 'false' 不弹
     */
    this.$nextTick(() => {
      console.log(this.complexityPopup, this.$store.state.user.complexityPopup, typeof this.complexityPopup, this.complexityPopup === 'true', '--------complexityPopup homeIndex----------');
      if (this.complexityPopup && this.complexityPopup == 'true') {
        console.log('--------弹弹弹passwordSafeModal----------');
        this.visibleModal = true;
      } else {
        console.log('false不弹');
        this.visibleModal = false;
      }
    });
  }
};